<template>
  <div class="see-housing-estate-detail-warp">
    <div class="housing-system-header">
      <div class="housing-system-left">{{`${orgName}—${projectName}`}}</div>
      <div class="housing-system-right">
        <!-- <div class="system-left">{{projectName}}</div> -->
        <!-- <div class="system-right" @click="goBack">退出个人查询</div> -->
        <div class="system-right" @click="goNew" v-if="more">返回小区列表</div>
      </div>
    </div>
    <div class="housing-estate-detail-content" :class="pageType==='1'?'active':''">
      <el-tabs v-model="pageType">
        <el-tab-pane lazy label="房源公示" name="1">
          <section class="pane-content">
            <housingResource @change="handleChange" @add="handleAdd" @addTableHouseNum="addTableHouseNum" @getData="getData" ref="housingResource" @getList="getList" :isOverflow="isOverflow" :selectedLength="selectedLength" :optionalResettlementTotalArea="householdData.optionalResettlementTotalArea" :selectedArea="selectedArea" :houseId="houseId" :house="house" :houseIdItem="houseIdItem" :selectHouseMaxCount="householdData.selectHouseMaxCount" :selectedData="selectedData" :totalhouseTypeList="totalhouseTypeList" :householdTableData="householdTableData" :selectedTierBuildingHousingArea="selectedTierBuildingHousingArea"></housingResource>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="小区介绍" name="2">
          <section class="pane-content">
            <estateIntroduce></estateIntroduce>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="户型介绍" name="3" v-if="houseIntroduceList.length">
          <section class="pane-content">
            <imagesShow :page-size="3" :list="houseIntroduceList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="效果图" name="4" v-if="effectImagesList.length">
          <section class="pane-content">
            <imagesShow :list="effectImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="规划图" name="5" v-if="planImagesList.length">
          <section class="pane-content">
            <imagesShow :list="planImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="实景图" name="6" v-if="liveActiveImagesList.length">
          <section class="pane-content">
            <imagesShow :list="liveActiveImagesList"></imagesShow>
          </section>
        </el-tab-pane>
        <el-tab-pane lazy label="配套类" name="7" v-if="environmentImagesList.length">
          <section class="pane-content">
            <imagesShow :list="environmentImagesList"></imagesShow>
          </section>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="test" v-show="pageType === '1'">
      <div class="useless">
        <img src="../../../assets/img/u143.svg" alt style="width:100px;height:100px;display:block;margin-left:90px;margin-bottom: 30px;" />
        <p class="un-select-house-p">当前项目未启用在线选房</p>
      </div>
    </div>
  </div>
</template>

<script type='text/babel'>
import Nav from '@/components/nav.vue';
import housingResource from './components/housingResource';
import estateIntroduce from './components/estateIntroduce';
import imagesShow from './components/imagesShow';
import {
  getHousingHouseTypeAndAttachmentList,
  getEstateAttachmetsTypeList,
  logoutHouseholdIndex,
  queryHouseholdHouseTaoTypeAndSelectHouseNumList
} from '@/api/xian-publicinquiry.api.js';
import { setSession, getSession, decodeURI, removeSession, isUndef } from '@/untils';
import Cookies from 'js-cookie';
import { addition, subtract } from '@/untils/math';
export default {
  name: 'housing-estate-detail',
  computed: {
    more() {
      let num = isUndef(getSession('total')) ? 0 : Number(getSession('total'));
      return num > 1;
    },
    bottomBindClass() {
      if (this.householdTableData.length == 1) {
        return 'test-bottom test-bottom1';
      } else if (this.householdTableData.length == 2) {
        return 'test-bottom test-bottom2';
      } else if (this.householdTableData.length >= 3 && this.householdData.selectHouseType !== 5) {
        return 'test-bottom test-bottom3';
      } else if (this.householdTableData.length == 0) {
        if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
          return 'test-bottom test-bottom4';
        } else {
          if (this.householdData.optionalResettlementTotalArea === 99999) {
            return 'test-bottom test-bottom5'
          }
        }
      }
      if (this.householdData.selectHouseType === 5) return 'test-bottom test-bottom6';
      return 'test-bottom';
    },
    bottomNoneClass() {
      if (this.householdTableData.length == 1) {
        return 'test-bottom-none test-none-bottom1';
      } else if (this.householdTableData.length == 2) {
        return 'test-bottom-none test-none-bottom2';
      } else if (this.householdTableData.length >= 3 && this.householdData.selectHouseType !== 5) {
        return 'test-bottom-none test-none-bottom3';
      } else if (this.householdTableData.length == 0) {
        if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
          return 'test-bottom-none test-none-bottom4';
        } else {
          if (this.householdData.optionalResettlementTotalArea === 99999) {
            return 'test-bottom-none test-none-bottom5'
          }
        }
      }
      if (this.householdData.selectHouseType === 5) return 'test-bottom-none test-none-bottom6';
      return 'test-bottom-none';
    },
    isSelectHouse() {
      return this.householdData.isSelectHouse === 1;
    },
    selectedArea() {
      const total = this.selectedData.reduce((pre, cur) => {
        const cba = cur.buildingArea || 0;
        return addition(pre, cba);
      }, 0);
      return total;
    },
    overflowArea() {
      if (Number(this.selectedArea) > Number(this.householdData.resettlementCompensationArea)) {
        return subtract(this.selectedArea, this.householdData.resettlementCompensationArea);
      } else {
        return 0;
      };
    },
    isOverflow() {
      return subtract(this.selectedArea, this.householdData.optionalResettlementTotalArea) >= 0;
    },
    selectedData() {
      const arr = [...this.houseList, ...this.selectedList];
      return arr;
    },
    selectedLength() {
      return this.selectedData.length;
    },
    propertyOwner() {
      if (this.householdData.propertyOwner) {
        return this.householdData.propertyOwner.length > 10 ? this.householdData.propertyOwner.substring(0, 10) + '...' : this.householdData.propertyOwner;
      } else {
        return this.householdData.propertyOwner;
      }
    },
    // 储藏室
    selectedStoreroomArea() {
      return this.householdTableData[2].selectHouseNum || '';
    },
    // 高层
    selectedHighBuildingHousingArea() {
      return this.householdTableData[1].selectHouseNum || '';
    },
    // 多层
    selectedTierBuildingHousingArea() {
      return this.householdTableData[0].selectHouseNum || '';
    }
  },
  data() {
    const { query } = this.$route;
    return {
      selectedList: [],
      query,
      pageType: '1',
      firstLoadPage: false,
      houseIntroduceList: [],
      houseList: [],
      effectImagesList: [],
      planImagesList: [],
      liveActiveImagesList: [],
      environmentImagesList: [],
      projectId: '',
      backName: '返回选房列表',
      backPath: 'selectionDetail',
      orgName: '',
      projectName: '',
      houseId: '',
      house: {},
      houseIdItem: '',
      householdData: {
        address: '',
        certificateNumber: '',
        householdCode: '',
        householdId: '',
        isSelectHouse: 1,
        selectHouseMaxCount: '',
        phone: '',
        projectId: '',
        propertyOwner: '',
        resettlementCompensationArea: 0,
        optionalResettlementTotalArea: 0,
        verifyCode: ''
      },
      totalhouseTypeList: [],
      householdTableData: [
        {
          typeName: '多层',
          resettlementNum: '',
          selectHouseNum: '',
          residualArea: ''
        },
        {
          typeName: '高层',
          resettlementNum: '',
          selectHouseNum: '',
          residualArea: ''
        },
        {
          typeName: '储藏室',
          resettlementNum: '15',
          selectHouseNum: '',
          residualArea: ''
        }
      ],
      contentStyleObj: {
        height: ''
      },
    };
  },
  created() {
    const list = getSession('houseList');
    this.houseList = !isUndef(list) && list.length > 0 ? list : [];
    this.orgName = getSession('newOrgName');
    this.projectName = getSession('projectName');
    this.projectId = getSession('projectId');
    if (this.query.pageType) {
      this.$set(this, 'pageType', this.query.pageType);
      this.$nextTick(() => {
        this.firstLoadPage = true;
      });
    } else {
      this.firstLoadPage = true;
    }
    this.getHousingHouseTypeAndAttachmentList();
    this.getEstateAttachmetsTypeList();
  },
  beforeDestroy() {
    this.$store.commit('setHouseList', []);
  },
  methods: {
    addTableHouseNum(data) {
      // debugger;
      this.householdTableData = data;
    },
    getData(data) {
      this.householdData = data;
      if (this.householdData.selectHouseType === 1 || this.householdData.selectHouseType === 4) {
        this.queryHouseholdHouseTaoTypeAndSelectHouseNumList({ householdId: this.householdData.householdId, projectId: this.projectId });
      }
    },
    handleRemove(itemId) {
      this.houseId = itemId.id;
      this.house = itemId;
      this.houseIdItem = itemId.orgTaoTypeId;
      this.houseList = this.houseList.filter(item => item.id !== itemId.id);
      console.log(this.houseList, 'lllllll');
      this.$store.commit('setHouseList', this.houseList);
      this.$nextTick(() => {
        this.$refs.housingResource.removeHouse();
      });
    },
    refresh() {
      this.$refs.housingResource.queryHouseholdIndex();
    },
    handleConfirm() {
      this.$refs.housingResource.handleChoose();
    },
    handleAdd(data) {
      this.houseList.unshift(data);
      this.$store.commit('setHouseList', this.houseList);
    },
    handleChange() {
      this.houseList = [];
      this.selectedList = [];
      this.$store.commit('setHouseList', this.houseList);
    },
    queryHouseholdHouseTaoTypeAndSelectHouseNumList(params) {
      queryHouseholdHouseTaoTypeAndSelectHouseNumList(params).then(res => {
        if (res.code === 0) {
          this.householdTableData = res.body;
        }
      })
    },
    getHousingHouseTypeAndAttachmentList() {
      getHousingHouseTypeAndAttachmentList(this.projectId, this.query.id).then(
        res => {
          if (res.code === 0) {
            this.totalhouseTypeList = res.body
            const data = res.body;
            this.houseIntroduceList.splice(0, this.houseIntroduceList.length);
            data.forEach(item => {
              const {
                id,
                houseType,
                buildingArea,
                howBedroom,
                typeAttachmentList
              } = item;
              const exist = typeAttachmentList && typeAttachmentList[0];
              const imgUrl =
                exist &&
                decodeURI(
                  `/housing/source/downloadHousingHouseTypeAttachment/${exist.id}/0`
                );
              const littleImg = imgUrl || require('@/assets/img/noPhoto.jpeg');
              const path = imgUrl || require('@/assets/img/noPhoto_large.jpeg');
              this.houseIntroduceList.push({
                id,
                info: {
                  houseType,
                  buildingArea,
                  howBedroom
                },
                url: {
                  littleImg: littleImg,
                  path: path
                }
              });
            });
          } else {
            this.$message({
              message: res.errMsg,
              type: 'warning'
            });
          }
        }
      );
    },
    getEstateAttachmetsTypeList() {
      getEstateAttachmetsTypeList({ estatdId: this.query.id }).then(res => {
        if (res.code === 0) {
          const data = res.body;
          const allImagesList = [
            { list: 'effectImagesList', name: '效果图' },
            { list: 'planImagesList', name: '规划图' },
            { list: 'liveActiveImagesList', name: '实景图' },
            { list: 'environmentImagesList', name: '配套类' }
          ];
          allImagesList.forEach(f => {
            const { list, name } = f;
            const onlineList = data.filter(d => d.name === name)[0]
              .estateAttachmentList;
            this[list].splice(0, this[list].length);
            onlineList.forEach(item => {
              const imgUrl = decodeURI(
                `/housing/source/estatephoto/download/${item.id}/0`
              );
              const littleImg = imgUrl || require('@/assets/img/noPhoto.jpeg');
              const path = imgUrl || require('@/assets/img/noPhoto_large.jpeg');
              this[list].push({
                id: item.id,
                url: {
                  littleImg: littleImg,
                  path: path
                }
              });
            });
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    goBack() {
      this.$confirm('确定要退出个人查询么?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logoutHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              removeSession('token');
              removeSession('session');
              removeSession('selectFlag');
              removeSession('tierBuildingHouseIds');
              removeSession('highBuildingHouseIds');
              removeSession('userInfo');
              Cookies.remove('token');
              Cookies.remove('yz_session_id');
              this.$store.commit('setHouseList', []);
              this.$router.push({ path: '/selection' });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    goNew() {
      this.$store.commit('setHouseList', []);
      this.$router.push({ path: '/xian' });
    },
    getList(data) {
      this.selectedList = data;
    }
  },
  watch: {
    // pageType: {
    // handler(val, oldVal) {
    //   if (val !== oldVal && this.firstLoadPage) {
    //     const { query } = this.$route;
    //     const copyQuery = JSON.parse(JSON.stringify(query));
    //     copyQuery.pageType = this.pageType;
    //     this.$router.replace({
    //       path: 'housingEstateDetail',
    //       query: copyQuery
    //     });
    //   }
    // }
    // }
  },
  components: {
    Nav,
    housingResource,
    estateIntroduce,
    imagesShow
  }
};
</script>
<style scoped lang="less">
.see-housing-estate-detail-warp {
  position: relative;
  background: #fff;
  height: 100%;
  width: 100%;
  div {
    box-sizing: border-box;
  }
  // display: flex;
  // flex-direction: column;
  .test {
    position: absolute;
    right: 10px;
    width: 280px;
    height: calc(~"100% - 60px");
    border-width: 1px;
    border-style: solid;
    border-color: rgba(204, 204, 204, 1);
    top: 50px;
    .useless {
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translateY(-50%);
    }
    .test-top {
      // height: 150px;
      padding: 5px 10px;
      .test-top-content {
        width: 100%;
        height: 100%;
        padding-bottom: 10px;
        background-color: rgba(242, 242, 242, 1);
        .test-top-two {
          padding: 10px 0;
          padding-left: 5px;
          font-size: 14px;
        }
        .test-top-two-str {
          padding: 5px 0;
          padding-left: 5px;
          font-size: 14px;
        }
        .test-top-btn {
          width: 120px;
          height: 30px;
          background-color: rgba(2, 91, 145, 1);
          font-size: 14px;
          color: #ffffff;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
          line-height: 30px;
          margin: auto;
          &:hover {
            background: rgb(53, 124, 167);
          }
        }
        .text-top-table {
          width: 100%;
        }
      }
    }
    .test-bottom-none {
      overflow: auto;
      height: calc(~"100% - 200px");
      margin-bottom: 10px;
    }
    .un-select-house-p {
      font-size: 14px;
      text-align: center;
      color: #999999;
      line-height: 35px;
    }
    .test-bottom {
      overflow: auto;
      height: calc(~"100% - 245px");
      margin-bottom: 10px;
    }
    .test-bottom1 {
      height: calc(~"100% - 295px");
    }
    .test-bottom2 {
      height: calc(~"100% - 315px");
    }
    .test-bottom3 {
      height: calc(~"100% - 335px");
    }
    .test-bottom4 {
      height: calc(~"100% - 320px");
    }
    .test-bottom5 {
      height: calc(~"100% - 200px");
    }

    .test-bottom6 {
      height: calc(~"100% - 270px");
    }
    //未选房
    .test-none-bottom1 {
      height: calc(~"100% - 295px");
    }
    .test-none-bottom2 {
      height: calc(~"100% - 315px");
    }
    .test-none-bottom3 {
      height: calc(~"100% - 335px");
    }
    .test-none-bottom4 {
      height: calc(~"100% - 270px");
    }
    .test-none-bottom5 {
      height: calc(~"100% - 200px");
    }
    .test-none-bottom6 {
      height: calc(~"100% - 270px");
    }
    .btn-refresh {
      width: 120px;
      height: 30px;
      background-color: rgba(2, 91, 145, 1);
      font-size: 14px;
      color: #ffffff;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      line-height: 30px;
      margin: auto;
      &:hover {
        background: rgb(53, 124, 167);
      }
    }
  }
  .housing-system-header {
    height: 40px;
    border-bottom: 1px solid rgb(2, 91, 145);
  }
  .housing-system-left {
    float: left;
    padding: 5px 0;
    text-indent: 15px;
    color: #025b91;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
  }
  .housing-system-right {
    float: right;
    display: flex;
  }
  .system-left {
    // margin-right: 224px;
    padding: 5px 150px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #1e1e1e;
  }
  .system-right {
    margin-right: 15px;
    line-height: 30px;
    text-align: center;
    width: 100px;
    height: 30px;
    background: inherit;
    background-color: rgba(2, 91, 145, 1);
    border: none;
    border-top: 0px;
    border-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
  .housing-estate-detail-content {
    // flex: 1;
    box-sizing: border-box;
    overflow: hidden;
    padding: 10px 30px;
    height: calc(~"100% - 40px");
    // padding-left: 50px;
    // width: 80%;
    /deep/ .el-tabs {
      width: 100%;
      height: 100%;
      // display: flex;
      // flex-direction: column;
      .el-tabs__header {
        margin-bottom: 0;
      }
      .el-tabs__content {
        // flex: 1;
        border: 1px solid #e4e7ed;
        overflow: hidden;
        height: calc(~"100% - 40px");
        .el-tab-pane {
          width: 100%;
          height: 100%;
          .pane-content {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .active {
    width: calc(~"100% - 280px");
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/see/see.vue